<div class="ad-select-button">
  <div
    *ngFor="let option of options; let i = index"
    [class]="classNames(i)"
    [ngClass]="{ 'ad-select-button-item-selected': value === option.value }"
    (click)="onItemClick($event, option, i)"
  >
    <span class="ad-select-button-label">{{ option.label }}</span>
  </div>
</div>
